import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CoreTracking } from "../../../models/CoreTracking";
import { RequestState } from "../../../models/RequestState";
import { RootState } from "../../../store/store";
import { useEffect } from "react";
import { GetGoogleDeviceTrackings } from "../../../store/DeviceAction";
import TrackingsModule from "../../administration/components/TrackingsModule";
import React from "react";
import { FlowSyncObjectType } from "../../../models/CoreModels";

const DeviceViewTrackings = () => {
    const { t } = useTranslation(['device']);

    const { googleDeviceId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.device.googleDeviceTrackings);

    useEffect(() => {
        if (googleDeviceId !== undefined) {
            GetGoogleDeviceTrackings(googleDeviceId)(dispatch);
        }
    }, [dispatch, googleDeviceId]);

    const fetchTrackings = () => {
        if (googleDeviceId !== undefined) {
            GetGoogleDeviceTrackings(googleDeviceId, true)(dispatch); 
        }
    }
    return (<>
        <TrackingsModule
            flowSyncObjectType={FlowSyncObjectType.Device}
            trackings={trackings}
            noResMsg={t('device.trackings.noResMsg', { ns: 'device'})}
            onDataInvalidated={fetchTrackings}
        />
    </>)
}

export default DeviceViewTrackings;


